import moment from 'moment';
import settings from './settings';

function precise(x, significantDigits = settings.SIGNIFICANT_DIGITS) {
  return Number.parseFloat(x).toPrecision(significantDigits);
}

const formatData = (data) => {

  const property = data[0]
  const value = data[1]

  const formatters = {
    'Sample Time' : time => {
      const fixed = time.split('_').join('T')
      return moment(fixed).format('MM-D-YYYY h:mm:ss a') 
    },
    'Commit Time' : time => {
      const fixed = time.split('_').join('T')
      return moment(fixed).format('MM-D-YYYY h:mm:ss a') 
    },
    'Speed': val => `${precise(val)} mph`,
    'Course': val => precise(val),
    'Temperature': val => `${precise(val, 4)} ˚F`,
    'Humidity': val => `${precise(val, 4)} %`,
    'Light': val => `${precise(val)} lux`,
    'Timeout': val => val,
    'ID': val => val
  }

  try {
    return formatters[property](value)
  } catch(error) {
    return 'unsupported data type' 
  }

};

const formatData2 = (data) => {

  console.log(data);
  const property = data[0]
  const value = data[1]

  const formatters = {
    'sampleTime' : time => {
      const fixed = time.split('_').join('T')
      return moment(fixed).format('MM-D-YYYY h:mm:ss a') 
    },
    'commitTime' : time => {
      const fixed = time.split('_').join('T')
      return moment(fixed).format('MM-D-YYYY h:mm:ss a') 
    },
    'speed': val => `${precise(val)} mph`,
    'course': val => precise(val),
    'temperature': val => `${precise(val, 4)} ˚F`,
    'humidity': val => `${precise(val, 4)} %`,
    'light': val => `${precise(val)} lux`,
    'timeout': val => val,
    'uuid': val => val
  }

  try {
    return formatters[property](value)
  } catch(error) {
    return 'unsupported data type' 
  }

}

export default formatData

